export enum SaveStatus {
	Saving = 'saving',
	Saved = 'saved',
	Failed = 'failed'
}
